import { SET_ACCOUNTS, SET_SELECTED_LCV_ACCOUNT, UPDATE_ACCOUNTS } from './actions';
import {
	GET_ACCOUNTS_PAGE_SUCCESS,
	GET_ACCOUNTS_BY_CAPABILITY_SUCCESS,
	GET_ACCOUNT_DETAILS_SUCCESS,
	GET_ACCOUNT_DETAILS_BY_ID_SUCCESS,
} from '../accountPaging/constants';
import { formatAccounts, formatAccount } from '../accountPaging/utils/account-parsing/formatAccounts';

const reducer = (state = [], action) => {
	switch (action.type) {
		case SET_ACCOUNTS:
			return [...state, ...action.accounts];
		case GET_ACCOUNT_DETAILS_SUCCESS:
		case GET_ACCOUNTS_PAGE_SUCCESS:
			// We want to retain any accounts that are involved in payments which have just been set via SET_SELECTED_LCV_ACCOUNT
			const isLCV = action.meta && action.meta.isLCV;

			if (!isLCV) return [...state, ...formatAccounts(action.payload.accounts)];
			return state;
		case SET_SELECTED_LCV_ACCOUNT: {
			const { accounts } = action;
			const updatedAccounts = accounts.filter(
				(account) => !state.some((stateAccount) => stateAccount.id === account.id)
			);
			return [...state, ...updatedAccounts];
		}
		case GET_ACCOUNTS_BY_CAPABILITY_SUCCESS:
			return [...state, ...formatAccounts(action.payload.accounts)];
		case GET_ACCOUNT_DETAILS_BY_ID_SUCCESS:
			return [...state, formatAccount(action.payload)];
		case UPDATE_ACCOUNTS:
			return [...state, ...formatAccounts(action.accounts)];
		default:
			return state;
	}
};
export default reducer;
